import CandidatesIcon from 'assets/images/iPrise/Candidates.svg';
import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import ReportsIcon from 'assets/images/iPrise/Reports.svg';
import TeamIcon from 'assets/images/iPrise/Team.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const ManagerHeader: React.FC = () => {
  const navItems: NavItem[] = [
    { icon: JobQueueIcon, label: 'Job Queue', path: '/manager/job-queue' },
    {
      icon: CandidatesIcon,
      label: 'Candidates',
      path: '/manager/candidates',
    },
    { icon: TeamIcon, label: 'My Team', path: '/manager/teams' },
    { icon: ReportsIcon, label: 'Reports', path: '/manager/reports' },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/manager/profile"
      basePath="/manager"
    />
  );
};

export default ManagerHeader;
